"use client";

import Script from "next/script";

export const ADSENSE_CLIENT_ID = "ca-pub-2214184889025947";

/**
 * Loads Google AdSense (Auto Ads).
 *
 * Auto Ads need only this loader — Google places the units itself, so there are
 * no hand-built ad slots to maintain. The script is a no-op until the site is
 * approved under Sites in the AdSense account, so it is safe to ship ahead of
 * approval (and in fact must be: AdSense rejects a site it reviews with no ad
 * code on it).
 */
export default function AdSense() {
  return (
    <Script
      id="adsbygoogle-loader"
      src={`https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js?client=${ADSENSE_CLIENT_ID}`}
      crossOrigin="anonymous"
      strategy="afterInteractive"
    />
  );
}
